module.exports = __webpack_public_path__ + "static/media/decadencia_del_neoliberalismo.ac48a8ea.md";